import React from 'react';
import PropTypes from 'prop-types';
import RippleButton from './RippleButton';
import { getFullUrl } from 'utils/utils';
import ShipPlayPromiseImage from '../../images/shipplay/inspirato/shipplay-promise.png'

const ShipAndPlayPromise = ({ buttonCTAPath = '/ship' }) => {
  const checkItems = [
    ['On-time guarantee', 'Fully insured', 'Real-time tracking'],
    ['Personal Service', 'Cost-effective', 'Shipment protection']
  ];

  return (
    <div className="bg-white text-center lg:text-left px-8 py-14 lg:px-24 xl:px-44 2xl:px-60 lg:py-16 w-full">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:gap-10 items-center">
        <div className="flex-1 space-y-4 md:space-y-0 md:flex md:flex-col lg:w-1/2 text-[#1C2938]">
          <h1 className="text-[32px] leading-[58px] font-bold mb-4">Ship&Play Promise</h1>
          <p className="text-lg leading-[30px] mb-5">
            Ship&Play Promises a dedicated team that is committed to
            helping you make travel hassle-free travel, every time. We&apos;ll take
            care of your luggage so you can focus on making memories.
          </p>
          <div className="flex flex-col lg:flex-row items-start md:items-center gap-4 lg:gap-12 py-8 lg:py-10">
            {checkItems.map((column, index) => (
              <div key={index} className="flex flex-col gap-4">
                {column.map((text, itemIndex) => (
                  <CheckItem key={itemIndex} text={text} />
                ))}
              </div>
            ))}
          </div>
          <div className="flex justify-left my-8">
            <RippleButton
              onClick={() => window.location.href = getFullUrl(buttonCTAPath, window.gon.subdomain)}
              className="
                flex items-center justify-center bg-[#49C44F] text-white rounded-full border-b-2 border-[#3fac45]
                font-medium px-5 py-8 h-[48px] w-full md:w-3/4 lg:w-1/2 lg:max-w-56 text-lg mx-auto lg:mx-0
              "
            >
              Book Now
            </RippleButton>
          </div>
        </div>
        <div className="flex lg:w-1/2 justify-center items-center mt-9 lg:mt-0">
          <img src={ShipPlayPromiseImage} alt="ShipSticks" className="w-[14.6875rem] lg:w-[497px] max-h-56" />
        </div>
      </div>
    </div>
  );
};

const CheckItem = ({ text }) => (
  <div className="flex items-center gap-4">
    <span className="text-green-500 text-xl">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
        <title>Checkmark</title>
        <path
          fillRule="evenodd"
          d="
            M20.707 5.293a1 1 0 010 1.414l-11 11a1 1 0 01-1.414 0l-5-5a1 1 0
            011.414-1.414L9 15.586l10.293-10.293a1 1 0 011.414 0z
          "
          clipRule="evenodd"
        />
      </svg>
    </span>
    <p className="text-lg">{text}</p>
  </div>
);

CheckItem.propTypes = {
  text: PropTypes.string,
};

ShipAndPlayPromise.propTypes = {
  buttonCTAPath: PropTypes.string,
};

export default ShipAndPlayPromise;
